import React from 'react'
import { IconProps, IconWrapper } from './IconWrapper'
const renderIcon = (color: string) => (
    <path
        fillRule='evenodd'
        clipRule='evenodd'
        d='M3.25 12C3.25 11.5858 3.58579 11.25 4 11.25L20 11.25C20.4142 11.25 20.75 11.5858 20.75 12C20.75 12.4142 20.4142 12.75 20 12.75L4 12.75C3.58579 12.75 3.25 12.4142 3.25 12Z'
        fill={color}
    />
)
export const Minus: React.FC<IconProps> = ({ color, size }) => <IconWrapper {...{ size, color, renderIcon }} />
